angular.module('elfium').filter('elfiumConvertFieldTypes', function () {
    var that = this;
    that.fieldTypesConstant = {};
    that._convertFieldTypes = function (inputObject) {
        angular.forEach(that.fieldTypesConstant.BOOLEAN, function (booleanFieldName) {
            if (inputObject[booleanFieldName] === '1') {
                inputObject[booleanFieldName] = true;
            } else if (inputObject[booleanFieldName] === '0') {
                inputObject[booleanFieldName] = false;
            }
        });
        angular.forEach(that.fieldTypesConstant.DATE, function (booleanFieldName) {
            if (inputObject[booleanFieldName] != null && !angular.isDate(inputObject[booleanFieldName])) {
                inputObject[booleanFieldName] = new Date(inputObject[booleanFieldName]);
            }
        });
    };
    return function (fieldTypesConstant, inputObject) {
        that.fieldTypesConstant = fieldTypesConstant;
        if (angular.isArray(inputObject)) {
            angular.forEach(inputObject, that._convertFieldTypes);
        } else if (inputObject) {
            that._convertFieldTypes(inputObject);
        }
        return inputObject;
    };
});


// WEBPACK FOOTER //
// ./src/app/components/elfium/elfiumConvertFieldTypesFilter.ts